import { InjectedConnector } from '@web3-react/injected-connector'
import { NetworkConnector } from '@web3-react/network-connector'

const RPC_URLS = {
  1: 'https://eth-mainnet.alchemyapi.io/v2/6cvFRKIvNvVXse7GJ4ZHOQtFYIV8giDx',
  4: 'https://rinkeby.infura.io/v3/84842078b09946638c03157f83405213',
  42: 'https://kovan.infura.io/v3/84842078b09946638c03157f83405213',
  1337: 'http://0.0.0.0:8545/',
}

export const injected = new InjectedConnector({
  supportedChainIds: [1, 3, 4, 5, 42, 50, 1337],
})

export const network = new NetworkConnector({
  urls: {
    1: RPC_URLS[1],
    4: RPC_URLS[4],
    42: RPC_URLS[42],
    1337: RPC_URLS[1337],
  },
  defaultChainId: 1,
})
